// extracted by mini-css-extract-plugin
module.exports = {"background":"#373940","foreground":"#999"};